// Reusable field validators. Each returns "" when valid, or an error message.
// Format validators pass on empty values so they can be composed with `required`
// (mandatory) or used alone (optional-but-must-be-valid-if-present).

const isEmpty = (v) => v === undefined || v === null || String(v).trim() === "";

export const required = (msg = "This field is required") => (v) => {
  if (Array.isArray(v)) return v.length ? "" : msg;
  return isEmpty(v) ? msg : "";
};

export const email = (msg = "Enter a valid email address") => (v) =>
  isEmpty(v) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim()) ? "" : msg;

export const phone = (msg = "Enter a valid phone number") => (v) =>
  isEmpty(v) || /^[+]?[\d][\d\s()-]{6,}$/.test(String(v).trim()) ? "" : msg;

export const number = (msg = "Enter a valid number") => (v) =>
  isEmpty(v) || !isNaN(Number(v)) ? "" : msg;

export const minNumber = (min = 0, msg) => (v) => {
  if (isEmpty(v)) return "";
  const n = Number(v);
  if (isNaN(n)) return msg || "Enter a valid number";
  return n < min ? (msg || `Must be ${min} or more`) : "";
};

export const maxNumber = (max, msg) => (v) => {
  if (isEmpty(v)) return "";
  const n = Number(v);
  if (isNaN(n)) return msg || "Enter a valid number";
  return n > max ? (msg || `Must be ${max} or less`) : "";
};

export const minLength = (len, msg) => (v) =>
  isEmpty(v) || String(v).length >= len ? "" : (msg || `Must be at least ${len} characters`);

export const gst = (msg = "Enter a valid 15-character GSTIN") => (v) =>
  isEmpty(v) || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(String(v).trim().toUpperCase())
    ? "" : msg;

export const pattern = (re, msg = "Invalid format") => (v) =>
  isEmpty(v) || re.test(String(v)) ? "" : msg;

// Run a list of validators against a value; return first error found.
export function validateField(validators, value) {
  for (const fn of validators || []) {
    const err = fn(value);
    if (err) return err;
  }
  return "";
}

// Validate a whole values object against a schema { field: [validators] }.
export function validateValues(schema, values) {
  const errors = {};
  for (const key in schema) {
    errors[key] = validateField(schema[key], values ? values[key] : undefined);
  }
  return errors;
}
